import React from 'react'
import styled from 'styled-components'

const StyledCheckboxInput = styled.input`
  cursor: pointer;
  margin: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  border: 2px solid ${({ theme }) => theme.forecast.border2};
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  appearance: none;
  position: relative;
  transition: all 0.2s ease;

  &:checked {
    background-color: ${({ theme }) => theme.forecast.primary || '#007BFF'};
    border-color: ${({ theme }) => theme.forecast.primary || '#007BFF'};
  }

  &:checked::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1;
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) =>
      theme.forecast.hoverGhostButton || '#007BFF'};
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.forecast.hoverButton || '#007BFF'};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    background-color: ${({ theme }) => theme.forecast.background3};
    border-color: ${({ theme }) => theme.forecast.textDisabled};
  }
`

export type TableCheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  // All standard HTML input checkbox props are supported
}

export const TableCheckbox = React.forwardRef<
  HTMLInputElement,
  TableCheckboxProps
>((props, ref) => {
  return <StyledCheckboxInput type='checkbox' ref={ref} {...props} />
})

TableCheckbox.displayName = 'TableCheckbox'
